module.exports = __webpack_public_path__ + "img/46.10.pH.36209854.png";